import { useEffect, useRef } from 'react';
export function useBeforeUnload(callback) {
    const ref = useRef();
    useEffect(() => {
        ref.current = (event) => {
            const returnValue = callback?.(event);
            // Handle legacy `event.returnValue` property (https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event)
            if (typeof returnValue === 'string') {
                return (event.returnValue = returnValue);
            }
            // Chrome doesn't support `event.preventDefault()` on `BeforeUnloadEvent`, instead it requires `event.returnValue` to be set (https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onbeforeunload#browser_compatibility)
            if (event.defaultPrevented) {
                return (event.returnValue = '');
            }
        };
    }, [callback]);
    useEffect(() => {
        const eventListener = (event) => {
            ref.current && ref.current(event);
        };
        window.addEventListener('beforeunload', eventListener);
        return () => {
            window.removeEventListener('beforeunload', eventListener);
        };
    }, []);
}
